/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

export default baseGt;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseGt.js
// module id = 306
// module chunks = 0